(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ceejay-services-deck"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cj-service-deck')) {
  customElements.define('cj-service-deck', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.track = this.querySelector('[data-cj-track]');
      this.cards = Array.from(this.querySelectorAll('[data-cj-card]'));
      this.tabs = Array.from(this.querySelectorAll('[data-cj-index]'));
      if (!this.track || !this.cards.length) return;
      this.active = 0;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.prev = this.querySelector('[data-cj-prev]');
      this.next = this.querySelector('[data-cj-next]');
      this.tabs.forEach(tab => tab.addEventListener('click', () => this.go(Number(tab.dataset.cjIndex)), {signal}));
      if (this.prev) this.prev.addEventListener('click', () => this.go(this.active - 1), {signal});
      if (this.next) this.next.addEventListener('click', () => this.go(this.active + 1), {signal});
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        this.go(event.key === 'Home' ? 0 : event.key === 'End' ? this.cards.length - 1 : this.active + (event.key === 'ArrowRight' ? 1 : -1));
      }, {signal});
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          if (this.track.scrollWidth <= this.track.clientWidth + 2 || getComputedStyle(this.track).display === 'grid') return;
          const trackRect = this.track.getBoundingClientRect();
          const left = trackRect.left + parseFloat(getComputedStyle(this.track).paddingLeft);
          let closest = 0;
          let distance = Infinity;
          this.cards.forEach((card, index) => {
            const delta = Math.abs(card.getBoundingClientRect().left - left);
            if (delta < distance) {distance = delta; closest = index;}
          });
          if (this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2) closest = this.cards.length - 1;
          this.setActive(closest);
        }, 100);
      }, {passive:true, signal});
      this.track.addEventListener('focusin', event => {
        const card = event.target.closest('[data-cj-card]');
        if (card) this.setActive(this.cards.indexOf(card));
      }, {signal});
      document.addEventListener('shopify:block:select', event => {
        const index = this.cards.findIndex(card => card.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.go(index);
      }, {signal});
      this.resizeObserver = new ResizeObserver(() => {
        this.classList.toggle("has-overflow",getComputedStyle(this.track).display !== "grid" && this.track.scrollWidth > this.track.clientWidth + 2);
        this.setActive(Math.min(this.active,this.cards.length - 1));
      });
      this.resizeObserver.observe(this.track);
      this.intersectionObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {this.classList.add('is-in-view');this.intersectionObserver.disconnect();}
      }, {threshold:0.08});
      this.intersectionObserver.observe(this);
      this.setActive(0);
    }
    setActive(index) {
      if (!this.cards[index]) return;
      this.active = index;
      this.cards.forEach((card,i) => card.classList.toggle('is-active',i === index));
      this.tabs.forEach((tab,i) => {tab.classList.toggle('is-active',i === index);tab.setAttribute('aria-pressed',String(i === index));});
      const name = this.querySelector('[data-cj-name]');
      const description = this.querySelector('[data-cj-description]');
      if (name && name.textContent !== this.cards[index].dataset.name) name.textContent = this.cards[index].dataset.name;
      if (description && description.textContent !== this.cards[index].dataset.description) description.textContent = this.cards[index].dataset.description;
      const count = this.querySelector('[data-cj-count]');
      if (count) count.textContent = String(index + 1).padStart(2,'0');
      const progress = this.querySelector('[data-cj-progress]');
      if (progress) progress.style.width = ((index + 1) / this.cards.length * 100) + '%';
      if (this.prev) this.prev.disabled = index === 0;
      if (this.next) this.next.disabled = index === this.cards.length - 1;
    }
    go(index) {
      index = Math.max(0,Math.min(this.cards.length - 1,index));
      this.setActive(index);
      const behavior = this.dataset.motion === 'off' || this.reduced.matches ? 'auto' : 'smooth';
      if (getComputedStyle(this.track).display !== 'grid' && this.track.scrollWidth > this.track.clientWidth + 2) {
        const left = this.cards[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft - parseFloat(getComputedStyle(this.track).paddingLeft);
        this.track.scrollTo({left,behavior});
      }
      if (this.tabs[index]) {
        const nav = this.tabs[index].parentElement;
        const left = this.tabs[index].offsetLeft - nav.offsetLeft;
        if (nav.scrollWidth > nav.clientWidth) nav.scrollTo({left,behavior});
      }
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = null;
      clearTimeout(this.scrollTimer);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.intersectionObserver) this.intersectionObserver.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
